var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6876 29.3899H21.3747C26.745 29.3899 27.7068 27.2391 27.9873 24.6207L28.9893 13.9336C29.3499 10.674 28.4148 8.01562 22.7106 8.01562H9.35168C3.64743 8.01562 2.7123 10.674 3.07299 13.9336L4.07491 24.6207C4.35545 27.2391 5.31729 29.3899 10.6876 29.3899Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6858 8.01568V6.94697C10.6858 4.58244 10.6858 2.67212 14.9606 2.67212H17.0981C21.3729 2.67212 21.3729 4.58244 21.3729 6.94697V8.01568",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7017 17.3669V18.7028C18.7017 18.7161 18.7017 18.7161 18.7017 18.7295C18.7017 20.1856 18.6884 21.3746 16.0299 21.3746C13.3849 21.3746 13.3582 20.199 13.3582 18.7429V17.3669C13.3582 16.031 13.3582 16.031 14.694 16.031H17.3658C18.7017 16.031 18.7017 16.031 18.7017 17.3669Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9227 14.6951C25.8368 16.9394 22.31 18.2753 18.7031 18.7295",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49768 15.0557C6.50343 17.1129 9.89659 18.3553 13.3565 18.7427",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.1dcabf3f.svg";
export { ForwardRef as ReactComponent };